module.exports = __webpack_public_path__ + "img/logo-white.f9279758.png";